
import Vue from 'vue';
import Component from 'vue-class-component';
import { db } from '@/plugins/firebase';
import { Project } from '@/types';

@Component
export default class SideMenu extends Vue {
  items = [
    { icon: 'home', title: 'ホーム', to: '/', key: 'm1' },
    { icon: 'fa-handshake', title: 'ごあいさつ', to: '/inspire', key: 'm2' },
    { icon: 'fa-medal', title: 'ランキング', to: '/leaderboard', key: 'm3' },
  ];
  learningMenus = [
    { icon: 'fa-graduation-cap', title: 'まなぶ', to: '/learn', key: 'l1' },
    { icon: 'fa-globe-asia', title: 'つながる', to: '/connect', key: 'l2' },
    {
      icon: 'fas fa-book',
      title: 'みんなの辞典',
      to: '/dict',
      key: 'l3',
    },
  ];
  projects: any = [];
  async created() {
    const snapshot = await db.collection('projects').get();
    snapshot.forEach(async (snap: any) => {
      const projectData = snap.data();
      projectData.id = snap.id;
      projectData.collections = [];
      const collections = await db
        .collection('collections')
        .where('projectId', '==', snap.id)
        .orderBy('title')
        .get();
      collections.forEach((c) => {
        const data = c.data();
        data.id = c.id;
        projectData.collections.push(data);
      });
      this.projects.push(projectData);
    });
  }
}
